export const OCR_TIMEOUT_MS = 5 * 60 * 1000;
export const OCR_TIMEOUT_MESSAGE = 'O OCR ficou 5 minutos sem resposta ou sem mudança de status. Tente enviar o arquivo novamente.';
